import { service } from '@/utils/request'
import { userInfoModule } from '@/api'

export interface IUserEditRequestParam {
  /**
   * 用户编码
   */
  id?: string
  /**
   * 备注
   */
  remark?: string

  tempAccount?: string

  tempPassword?: string

  nickName?: string
}

export interface IUserDetailResponse {
  /**
   * 用户编码
   */
  id?: string
  /**
   * 备注
   */
  remark?: string

  tempAccount?: string

  tempPassword?: string

  nickName?: string
}

export interface IUserListRequestParam {
  /**
   * 用户编码
   */
  merchantId?: number
  pageNo?: number
  pageSize?: number
  notInList?: []
  nickName?: string
}

export interface IUserAccountListRequestParam {
  /**
   * 用户编码
   */
  merchantId?: number
  pageNo?: number
  pageSize?: number
  userId?: number
  vipLevel?: number
  userRole?: string
}

/**
 * 更新用户备注
 * @param param
 */
export function updateUserInfo(param: IUserEditRequestParam): Promise<void> {
  return service.post(`${userInfoModule.updateUserApi}`, param)
}

/**
 * 更新用户信息
 * @param param
 */
export function updateUser(param: IUserEditRequestParam): Promise<void> {
  return service.post(`${userInfoModule.updateUserDeatilApi}`, param)
}

/**
 * 新增用户
 * @param param
 */
export function addUserInfo(param: IUserEditRequestParam): Promise<void> {
  return service.post(`${userInfoModule.addUserApi}`, param)
}

/**
 * 更新用户备注
 * @param param
 */
export function listUser(param: IUserListRequestParam): Promise<any> {
  return service.post(`${userInfoModule.listUserApi}`, param)
}

export function listUserAccount(param: IUserAccountListRequestParam): Promise<any> {
  return service.post(`${userInfoModule.listUserAccountApi}`, param)
}

export function editAccount(param: any): Promise<any> {
  return service.post(`${userInfoModule.editAccountApi}`, param)
}

export function listUserBind(param: IUserListRequestParam): Promise<any> {
  return service.post(`${userInfoModule.listUserBindApi}`, param)
}

/**
 * 查看用户信息
 * @param param
 */
export function userDetail(param: IUserListRequestParam): Promise<IUserDetailResponse> {
  return service.post(`${userInfoModule.detailUserApi}`, param)
}

export function addUserBind(param: any): Promise<any> {
  return service.post(`${userInfoModule.addUserBindApi}`, param)
}
export function getOrderList(param: any): Promise<any> {
  return service.post(`${userInfoModule.getOrderListApi}`, param)
}
